import {
  EPS_PER_CEF,
  EPS_PER_SF,
  FPM_PER_CEF,
  FPM_PER_SF,
} from '../constants/spread';

// [EPS_100_Paks]

/*
 * @todo Update 4.4.2022 >  setting a minimum of 3 paks for on prem ( [Enterprise SIEM Paks] and [Usage SIEM Paks] must be minimum 3)
 */

/**
 * Calculate the EPS peak
 * @param {number} workstations : Number of employees/workstations
 * @param {number} servers : Number of servers
 * @returns {number}
 */
export function EPSPeakCalculation(workstations: number, servers: number) {
  return (workstations * EPS_PER_CEF + servers * EPS_PER_SF) / 100;
}

// [FPM_10k_Paks]
/**
 * Calculate the FPM peak
 * @param {number} workstations : Number of employees/workstations
 * @param {number} servers : Number of servers
 * @returns {number}
 */
export function FPMPeakCalculation(workstations: number, servers: number) {
  return (workstations * FPM_PER_CEF + servers * FPM_PER_SF) / 10000;
}
